export const QUESTION_TYPE_KEYS = {
  QUESTION_TEXT: 'question_text',
  QUANTITY_A: 'quantity_a',
  QUANTITY_B: 'quantity_b',
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/question-type/question-type-keys.ts